import { Stack, TextField } from "@mui/material";
import { PropertyEditorProps } from "../../../../types/actionModule/editor/subtypeEditorTypes";
import { ChecklistAnswerItem, isChecklistAnswerItemArray } from "../../../../types/actionModule/subtypes/checklistAnswerSubtype";
import { GeneralButton } from "../../../../common/ui/GeneralButton";
import { Add, Delete } from "@mui/icons-material";
import { useCallback } from "react";

export function ChecklistAnswerItemsEditor(props: PropertyEditorProps) {
    const value = props.value;

    if (!isChecklistAnswerItemArray(value)) {
        return <>Invalid value</>;
    }

    return <Editor value={value} onChanged={props.onChanged} />
}

interface EditorProps {
    value: ChecklistAnswerItem[];
    onChanged: (newValue: ChecklistAnswerItem[]) => void;
}

function Editor(props: EditorProps) {
    const value = props.value;

    const onDeleteItem = useCallback((item: ChecklistAnswerItem) => {
        props.onChanged(
            value?.filter((v) => v !== item) as ChecklistAnswerItem[]
        );
    }, [value]);

    const onAddItem = useCallback(() => {
        const newValue: ChecklistAnswerItem[] = [
            ...(value ? value : []),
            {
                negativeCheckedReward: 0,
                notCheckedReward: 0,
                positiveCheckedReward: 0,
                text: "",
                id: value.reduce((x, y) => x > (y.id ?? 0) ? x : (y.id ?? 0), 0) + 1
            }
        ]

        props.onChanged(newValue);
    }, [value]);

    const onItemChanged = useCallback((item: ChecklistAnswerItem, newItem: ChecklistAnswerItem) => {
        const newValue: ChecklistAnswerItem[] = value.map((v) => v === item ? newItem : v)
        props.onChanged(newValue);
    }, [value]);

    return <Stack sx={{gap: 1, alignItems: "stretch", alignSelf: "stretch"}}>
        {
            value?.map((i: ChecklistAnswerItem) => <ChecklistItem
                key={i.id}
                item={i}
                onDelete={() => onDeleteItem(i)}
                onChange={(v) => onItemChanged(i, v)} />)
        }

        <GeneralButton appVariant="icon" onClick={onAddItem} sx={{ alignSelf: "start" }}>
            <Add /> Hinzufügen
        </GeneralButton>
    </Stack>;
}

interface ChecklistItemProps {
    item: ChecklistAnswerItem;
    onDelete: () => void;
    onChange: (newValue: ChecklistAnswerItem) => void;
}

function ChecklistItem(props: ChecklistItemProps) {
    return <Stack direction="row">
        <TextField
            size="small"
            fullWidth
            value={props.item.text}
            onChange={(e) => props.onChange({
                ...props.item,
                text: e.target.value
            })}
            variant="outlined"
        />
        <GeneralButton
            onClick={props.onDelete}
            appVariant="icon">
            <Delete />
        </GeneralButton>
    </Stack>
}